import { useMemo } from 'react';

import { type IMarketFilter, useCreateMarketFilters } from '@/creditflowresearch/application/PageFilters/hooks/create';
import { useRestrictedAccess } from '@/creditflowresearch/application/User/access/grants/useRestrictedAccess';
import { EuropeanMarket } from '@/creditflowresearch/domain/Market';

// TODO: remove when the European market opening period ends
export const useCorporateAccessibleMarkets = (): IMarketFilter[] => {
  const markets = useCreateMarketFilters();
  const isRestrictedToEuropeanMarket = useRestrictedAccess();

  return useMemo<IMarketFilter[]>(() => markets.map((market) => {
    if (!isRestrictedToEuropeanMarket || market.id === EuropeanMarket.MARKET_ID) {
      return market;
    }

    return {
      ...market,
      disabled: true,
    };
  }), [markets, isRestrictedToEuropeanMarket]);
};
